<template>
  <div>
    <a href="http://h5.eqxiu.com/ls/5HKMP2SH">
      <div class="main" style="background-image:url(static/img/act/6/banner/bg.jpg)" >
        <img class="act-6-banner-ship" v-bind:class="{'act-6-animation-ship-line':isShipShow,'act-6-animation-ship':isShipDegShow}" src="static/img/act/6/banner/ship.png">
        <img class="act-6-banner-liuzhou act-6-animation-liuzhou" src="static/img/act/6/banner/liuzhou.png"> 
        <img class="act-6-banner-2019 act-6-animation-2019" src="static/img/act/6/banner/2019.png"> 
        <img class="act-6-banner-title act-6-animation-title" src="static/img/act/6/banner/title.png">               
        <img class="act-6-banner-footer act-6-animation-footer" src="static/img/act/6/banner/footer.png">       
        <img class="act-6-banner-flower-top act-6-animation-flower-top" src="static/img/act/6/banner/flower-top.png">
        <img class="act-6-banner-swallow act-6-animation-swallow" src="static/img/act/6/banner/swallow.png">
        
        <img class="act-6-banner-petals-1 act-6-animation-petals-1" src="static/img/act/6/banner/petals.png">        
        <img class="act-6-banner-petals-2 act-6-animation-petals-2" src="static/img/act/6/banner/petals.png">
      </div>
    </a> 
  </div>
</template>
 

<script>
import NavTabbar from '@/components/NavTabbar.vue' 
import { ImagePreview } from "vant";
//动画
import Velocity from "velocity-animate";

export default {
  name: "Act6Banner",
  components: {
    'nav-tabbar': NavTabbar,   
    "van-image-preview": ImagePreview
  },
  data() {
    return {
      isShipShow:false,
      isShipDegShow:false,
    };
  },
  mounted() {
  },
  created() {    
    let vm = this
    //移除loading
    this.removeLoader()
    setTimeout(function(){
      vm.isShipShow = true
    },500)
    setTimeout(function(){
      vm.isShipShow = false
      vm.isShipDegShow = true
    },3500)    
    this.setDocumentV2(
      "2019年文博旅游艺术周",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/6/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '2019年文博旅游艺术周', '点击', 'Banner页面','0','6']);  
    //动画

  },
  methods: {
    handleVeforeEnter: (el) => {
      //console.log('动画开始前')
      //el.style.opacity = 0   
    },
      handleEnter: (el, done) => {
       console.log('开始!')
        Velocity(el, {
          rotateZ: "45deg"
        }, {
          easing: "swing",
          duration: 10000,
          complete: done
        })
      },
      handleAfterEnter: () => {
        console.log('动画结束')
      }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}


.act-6-banner-footer {
  position: absolute;
  width: 92%;
  left: 4%;
  top: 76%;
}
.act-6-banner-flower-top {
  position: absolute;
  width: 60%;
  right: 0;
  top: -15%;
}





.act-6-banner-swallow{  
  position: absolute;
    top: 17%;
    left: -26%;
    width: 14%;
    max-width: 100%;
} 


.act-6-banner-ship{
    position: absolute;
    top: 68%;
    left: -22%;
    width: 14%;
    max-width: 100%;
} 

@-webkit-keyframes act-6-frames-animation-ship {
  0% {
    -webkit-transform:translateY(-130%)  translateX(300%)   rotate(0deg);
    -webkit-transform-origin: center center;
    -moz-transform:translateY(-130%)  translateX(300%)   rotate(0deg);
    -moz-transform-origin: center center;
    transform:translateY(-130%)  translateX(300%)   rotate(0deg);
    transform-origin: center center;
  }
  20% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    transform-origin: center center;
  }
  40% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -moz-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    transform-origin: center center;
  }
  60% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%)  rotate(6deg);
    transform-origin: center center;
  }
  80% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -moz-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    transform-origin: center center;
  }
  100% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    transform-origin: center center;
  }
}

@keyframes act-6-frames-animation-ship {
  0% {
    -webkit-transform:  translateY(-130%)  translateX(300%) rotate(0deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(0deg);
    transform-origin: center center;
  }
  20% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    transform-origin: center center;
  }
  40% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(-6deg);
    transform-origin: center center;
  }
  60% {
    -webkit-transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    transform-origin: center center;
  }
  80% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    transform-origin: center center;
  }
  100% {
    -webkit-transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    transform-origin: center center;
  }
}

.act-6-animation-ship {
  -webkit-animation: act-6-frames-animation-ship 9s ease-in-out alternate infinite !important;
  animation: act-6-frames-animation-ship 9s ease-in-out alternate infinite !important;
}


@-webkit-keyframes act-6-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes act-6-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.act-6-animation-liuzhou {
  -webkit-animation-name: act-6-fadeIn;
  animation-name: act-6-fadeIn;
  -webkit-animation: act-6-fadeIn 0.5s ease-in-out both;
  -moz-animation: act-6-fadeIn 0.5s ease-in-out both;
  animation: act-6-fadeIn 0.5s ease-in-out both;
  animation-delay: 2600ms;
  -webkit-animation-delay: 2600ms;
}

.act-6-banner-liuzhou{    
    position: absolute;
    top: 13%;
    left: 20%;
    width: 55%;
    max-width: 100%;
} 

 
.act-6-animation-2019 {
  -webkit-animation-name: act-6-fadeIn;
  animation-name: act-6-fadeIn;
  -webkit-animation: act-6-fadeIn 0.5s ease-in-out both;
  -moz-animation: act-6-fadeIn 0.5s ease-in-out both;
  animation: act-6-fadeIn 0.5s ease-in-out both;
  animation-delay: 3000ms;
  -webkit-animation-delay: 3000ms;
}

.act-6-banner-2019{
  position: absolute;
  top: 18%;
  left: 52%;
  width: 26%;
  max-width: 100%;
} 


.act-6-animation-title {
  -webkit-animation-name: act-6-fadeIn;
  animation-name: act-6-fadeIn;
  -webkit-animation: act-6-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-6-fadeIn 0.8s ease-in-out both;
  animation: act-6-fadeIn 0.8s ease-in-out both;
  animation-delay: 3300ms;
  -webkit-animation-delay: 3300ms;
}

.act-6-banner-title{
 position: absolute;
    top: 35%;
    left: 34%;
    width: 31%;
    max-width: 100%;
} 



@keyframes act-6-frames-ship-line {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(-130%)  translateX(300%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(-130%)  translateX(300%);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%);
    transform-origin: center center;
  }
}

.act-6-animation-ship-line {  
  animation-name: act-6-frames-ship-line 3s both;
  -webkit-animation: act-6-frames-ship-line 3s both;
  -moz-animation: act-6-frames-ship-line 3s both;
  animation: act-6-frames-ship-line 3s both;
}

.act-6-animation-footer {
  -webkit-animation: act-6-fadeIn 0.5s ease-in-out both;
  animation: act-6-fadeIn 0.5s ease-in-out both;
  animation-delay: 3800ms;
  -webkit-animation-delay: 3800ms;
}

@keyframes act-6-frames-footer-top {
  0% { 
    opacity: 0;
    -webkit-transform: translateY(0%);
    transform: translateY(0%);
  } 
  100% {
    opacity: 1;    
    -webkit-transform: translateY(85%);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(85%);
    -moz-transform-origin: center center;
    transform:  translateY(85%);
    transform-origin: center center;
  }
}

.act-6-animation-flower-top {  
  animation-name: act-6-frames-footer-top 2s ease-in-out both;
  -webkit-animation: act-6-frames-footer-top 2s ease-in-out both;
  -moz-animation: act-6-frames-footer-top 2s ease-in-out both;
  animation: act-6-frames-footer-top 2s ease-in-out both;
  animation-delay: 3800ms;
  -webkit-animation-delay: 3800ms;
}


@keyframes act-6-frames-swallow {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(-130%)  translateX(300%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(-130%)  translateX(300%);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%);
    transform-origin: center center;
  }
}

.act-6-animation-swallow {  
  animation-name: act-6-frames-swallow 2s ease-in-out both;
  -webkit-animation: act-6-frames-swallow 2s ease-in-out both;
  -moz-animation: act-6-frames-swallow 2s ease-in-out both;
  animation: act-6-frames-swallow 2s ease-in-out both;
  animation-delay: 4400ms;
  -webkit-animation-delay: 4400ms;
}




.act-6-banner-petals-1{  
    position: absolute;
    width: 100%;
    left: 301%;
    top: -82%;
}
 
.act-6-banner-petals-2{  
    position: absolute;
    width: 80%;
    left: 299%;
    top: -17%;
}


@keyframes act-6-frames-petals-1 {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(330%)  translateX(-300%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(330%)  translateX(-300%);
    -moz-transform-origin: center center;
    transform:  translateY(330%)  translateX(-300%);
    transform-origin: center center;
  }
}

.act-6-animation-petals-1 {  
  animation-name: act-6-frames-petals-1 3s linear both;
  -webkit-animation: act-6-frames-petals-1 3s linear both;
  -moz-animation: act-6-frames-petals-1 3s linear both;
  animation: act-6-frames-petals-1 3s linear both;
  animation-delay: 3200ms;
  -webkit-animation-delay: 3200ms;
}


@keyframes act-6-frames-petals-2 {
  0% {
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  }
  100% {
    -webkit-transform: translateY(400%)  translateX(-550%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(400%)  translateX(-550%);
    -moz-transform-origin: center center;
    transform:  translateY(400%)  translateX(-550%);
    transform-origin: center center;
  }
}

.act-6-animation-petals-2 {  
  animation-name: act-6-frames-petals-2 1.5s linear both;
  -webkit-animation: act-6-frames-petals-2 1.5s linear both;
  -moz-animation: act-6-frames-petals-2 1.5s linear both;
  animation: act-6-frames-petals-2 1.5s linear both;
  animation-delay: 6000ms;
  -webkit-animation-delay: 6000ms;
}

</style>


// WEBPACK FOOTER //
// src/components/act/6/Banner.vue